// @ts-nocheck
/* eslint-disable */
globalThis.probe = {};
